import { CategoryForm } from "@/components";
import { useAppSelector } from "@/store/hooks";
import { ArrowLeft } from "lucide-react";
import { Link, useParams } from "react-router-dom";

const EditCategory = () => {
  const { id } = useParams<{ id: string }>();

  const selectedCategory = useAppSelector(
    (state) => state.app.categories.find((category) => category.id === id) || null
  );

  return (
    <div className="h-screen flex items-start flex-col    pl-14 pt-12">
        <div className="group h-10 md:px-4 py-2 mb-6  ">
        <Link to="/seller" className=" text-sm font-medium ">
          <ArrowLeft className="group-hover:translate-x-[-5px] transition-transform duration-300 h-4 w-4 inline-block mr-2" />
          Back to Inventory
        </Link>
      </div>
      <CategoryForm category={selectedCategory} isEditing={true} />
    </div>
  );
};

export default EditCategory;
